/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { html } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type TefComs from '@mfe/components/tef-coms';
import { PageDetails } from '@mfe/types/common';

export const pageFooter = (tefComs: TefComs) => html`
  <p>
  ${unsafeHTML((tefComs.details as PageDetails).pageFooter)}
  </p>`;

export default pageFooter;
